import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Grid,
  FormGroup,
} from '@mui/material';

export const ScheduleCard = ({useJobGeneralConfig}) => {
  const [schedule, setSchedule] = useJobGeneralConfig(["schedule"]);
  const {time, setTime, day, setDay, valid} = (function () {
    if(!schedule || schedule.length === 0) {
      return {
        valid: true,
        day: "",
        setDay: (d) => setSchedule(`00 00 * * ${d}`),
        time: "",
        setTime: (t) => {
          const [hour, minute] = t.split(":")
          setSchedule(`${minute} ${hour} * * 0`)
        },
      }
    }
    const parts = schedule.split(" ")
    if(parts.length !== 5) {
      return {valid: false}
    }
    const [minute, hour, _, __, day] = parts;
    if(!/^\d+$/.test(minute)) {
      return {valid: false}
    }
    if(!/^\d+$/.test(hour)) {
      return {valid: false}
    }
    if(!/^\d$/.test(day)) {
      return {valid: false}
    }
    const setTime = (t) => {
      const [hour, minute] = t.split(":")
      const newSchedule = `${minute} ${hour} * * ${day}`
      setSchedule(newSchedule)
    }
    const setDay = (d) => {
      const newSchedule = `${minute} ${hour} * * ${d}`
      setSchedule(newSchedule)
    }
    return {valid: true, time: `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`, day, setTime, setDay}
  })()
  const [runOnSchedule, setRunOnSchedule] = useJobGeneralConfig(["runOnSchedule"]);
  const scheduleOptions = [
    { 
      value: true,
      label: 'Weekly'
    },
    { 
      value: false,
      label: 'Schedule disabled'
    },
  ]
  const dayOptions = [
    { 
      value: "0",
      label: 'Sunday'
    },
    { 
      value: "1",
      label: 'Monday'
    },
    { 
      value: "2",
      label: 'Tuesday'
    },
    { 
      value: "3",
      label: 'Wednesday'
    },
    { 
      value: "4",
      label: 'Thursday'
    },
    { 
      value: "5",
      label: 'Friday'
    },
    { 
      value: "6",
      label: 'Saturday'
    },
  ]
  return <Card>
    <CardHeader title="Schedule" subheader="When the feed runs" />
    <CardContent>
      <FormGroup>
        <Grid container spacing={2}>
          {valid
            ? <>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Frequency"
                    name="freq"
                    onChange={(e) => setRunOnSchedule(e.target.value)}
                    required
                    value={runOnSchedule}
                    variant="standard"
                    helperText="From Empower paperwork"
                    select
                    // eslint-disable-next-line react/jsx-sort-props
                    SelectProps={{ native: true }}
                  >
                    {scheduleOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Day"
                    name="freq"
                    onChange={(e) => setDay(e.target.value)}
                    required
                    value={day}
                    variant="standard"
                    helperText="From Empower paperwork"
                    select
                    // The value starts empty, so the label has to stay raised or it sits on the placeholder.
                    // eslint-disable-next-line react/jsx-sort-props
                    InputLabelProps={{ shrink: true }}
                    // eslint-disable-next-line react/jsx-sort-props
                    SelectProps={{ native: true }}
                  >
                    <option value="" disabled>
                      {' '}
                    </option>
                    {dayOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    helperText="From Empower paperwork"
                    id="plan_id"
                    label="Time"
                    onChange={e => setTime(e.target.value)}
                    required
                    type="time"
                    value={time}
                    variant="standard"
                    // A time input always shows a browser placeholder. Keep the label raised so they do not overlap.
                    // eslint-disable-next-line react/jsx-sort-props
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Timezone"
                    name="tz"
                    required
                    variant="standard"
                    helperText="From Empower paperwork"
                    select
                    // eslint-disable-next-line react/jsx-sort-props
                    SelectProps={{ native: true }}
                    value="america/denver"
                  >
                    <option value="america/denver">
                      America/Denver
                    </option>
                  </TextField>
                </Grid>
              </>
            : "Unknown/custom time, please edit via the basic editor"
          }
        </Grid>
      </FormGroup>
    </CardContent>
  </Card>
}
